module.exports = __webpack_public_path__ + "img/bb_g1_t_ears-01.0b96996a.svg";